import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { catchError, map, tap, first } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/of';
import { Tchek } from '../model/tchek';
import { Device } from '../model/device';
import { of } from 'rxjs/observable/of';

import { UserService } from './user.service';
import { environment } from '../../environments/environment';

// PARSE
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from './parse.service';
import { Globals } from '../GlobalsExport';

import { NotificationsService } from 'angular2-notifications';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { FavoritePictureFilters } from '../model/detail';
import { ContractUpdate } from '../tchek/tchek-detail/contract-update';
import { Subject } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  params: new HttpParams()
};

@Injectable()
export class TchekOldService {

  private tchekBaseUrl =
    environment.baseURL + ':' + environment.portAPI + '/api/tchek';
  private vehicleBaseUrl =
    environment.baseURL + ':' + environment.portAPI + '/api/vehicle';
  private statusBaseUrl =
    environment.baseURL + ':' + environment.portAPI + '/api/device';

  private sendMailBaseUrl =
    environment.baseURL + ':' + environment.portAPI + '/api/mail';

  subscription: any;
  public totalTchek = new BehaviorSubject<number>(0);
  public statusSource = new BehaviorSubject<boolean>(true);

  // private baseUrl = 'api/tcheks';
  private tchekPath = '/root/Tchek_IHM/TchekApp/';
  tcheks = Array<Tchek>();
  private newTcheksSource = new BehaviorSubject<Tchek[]>([]);
  newTcheks = this.newTcheksSource.asObservable();
  notif: NotificationsService;
  constructor(
    private _http: HttpClient,
    private _userService: UserService,
    private parseSvc: ParseService,
    private _globals: Globals,
    private _notif: NotificationsService,
    private i18n: I18n,
    private datePipe: DatePipe
  ) {
    this.notif = _notif;
  }

  changeStatus(status: boolean) {
    this.statusSource.next(status);
  }

  setTotal(val: number) {
    this.totalTchek.next(val);
  }

  // Fonction qui permet de changer la valeur des newTcheks
  changeNewTcheks(newTcheks: Tchek[]) {
    this.newTcheksSource.next(newTcheks);
  }

  getTcheks_old(): Observable<Tchek[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }) //        Authorization: "Bearer " + this._userService.getUserToken()
    };
    return this._http.get<Tchek[]>(this.tchekBaseUrl, httpOptions).pipe(
      tap(tcheks => {
        this.log(`fetched tcheks`);
      }),
      catchError(this.handleError('getTcheks', []))
    );
  }

  getNewTcheks(): Observable<Tchek[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }) //        Authorization: "Bearer " + this._userService.getUserToken()
    };
    return this._http
      .get<Tchek[]>(this.tchekBaseUrl + '/new', httpOptions)
      .pipe(
        tap(tcheks => {
          this.log(`fetched new tcheks`);
        }),
        catchError(this.handleError('getNewTcheks', []))
      );
    // const url = `${this.tchekBaseUrl}/?isNew=true`;
    // return this.getTcheks();
  }

  // getTcheksByVehicleId(
  //   idVehicle: number,
  //   idTchek: number
  // ): Observable<Tchek[]> {
  //   let httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json"
  //     }) //        Authorization: "Bearer " + this._userService.getUserToken()
  //   };
  //   return this._http
  //     .get<Tchek[]>(
  //       this.vehicleBaseUrl + "/" + idVehicle + "/compareTchek/" + idTchek,
  //       httpOptions
  //     )
  //     .pipe(
  //       tap(tcheks => {
  //         this.log(`fetched tcheks`);
  //       }),
  //       catchError(this.handleError("getTcheks", []))
  //     );
  // }

  getTchek_old(tchekId: number): Observable<Tchek> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }) //        Authorization: "Bearer " + this._userService.getUserToken()
    };
    return this._http
      .get<Tchek>(this.tchekBaseUrl + '/' + tchekId, httpOptions)
      .pipe(
        tap(_ => {
          this.log(`fetched tchek id=${tchekId}`);
        }),
        catchError(this.handleError<Tchek>(`getTchek id=${tchekId}`))
      );
  }

  getPhotosForAnimation(tchekId: number): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }) //        Authorization: "Bearer " + this._userService.getUserToken()
    };
    return this._http
      .get<Tchek>(this.tchekBaseUrl + '/' + tchekId, httpOptions)
      .pipe(
        tap(_ => {
          this.log(`fetched tchek id=${tchekId}`);
        }),
        catchError(this.handleError<Tchek>(`getTchek id=${tchekId}`))
      );
    // return this._http.get<Tchek>("assets/images/animations/2018-04-16-17-19-04/TchekRawData.json").pipe(
    //   tap(_ => {
    //     this.log(`fetched tchek id=${tchekId}`);
    //   }),
    //   catchError(this.handleError<Tchek>(`getTchek id=${tchekId}`))
    // );
  }

  saveTchek(tchek: Tchek): Observable<Tchek> {
    return this._http.post<Tchek>(this.tchekBaseUrl, tchek, httpOptions).pipe(
      tap((tchekSaved: Tchek) => this.log(`saved tchek w/ id=${tchek.id}`)),
      catchError(this.handleError<Tchek>('saveTchek'))
    );
  }

  updateTchek(tchek: Tchek): Observable<Tchek> {
    return this._http.put(this.tchekBaseUrl, tchek, httpOptions).pipe(
      tap(_ => this.log(`updated tchek id=${tchek.id}`)),
      catchError(this.handleError<any>('updateTchek'))
    );
  }

  deleteTchekOld(tchek: Tchek | string): Observable<Tchek> {
    const id = typeof tchek === 'string' ? tchek : tchek.id;
    // const url = `${this.tchekBaseUrl}/${id}`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this._userService.getUserToken()
      })
    };
    return this._http
      .delete<Tchek>(this.tchekBaseUrl + '/' + id, httpOptions)
      .pipe(
        tap(_ => {
          this.log(`fetched tchek id=${id}`);
        }),
        catchError(this.handleError<Tchek>(`deleteTchek id=${id}`))
      );

    // return this._http.delete<Tchek>(url, httpOptions).pipe(
    //   tap(_ => this.log(`deleted tchek id=${id}`)),
    //   catchError(this.handleError<Tchek>('deleteTchek'))
    // );
  }

  doSearch_old(
    search: string,
    dateStart: string,
    dateEnd: string,
    intervalTime: string
  ): Observable<Tchek[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this._userService.getUserToken()
      }),
      params: new HttpParams()
    };
    if (intervalTime === 'false') {
      httpOptions.params = httpOptions.params
        .set('search', search)
        .set('dateStart', dateStart);
    } else {
      httpOptions.params = httpOptions.params
        .set('search', search)
        .set('dateStart', dateStart)
        .set('dateEnd', dateEnd);
    }
    return this._http
      .get<Tchek[]>(this.tchekBaseUrl + '/research', httpOptions)
      .pipe(
        tap(tcheks => {
          httpOptions.params = httpOptions.params
            .delete('search')
            .delete('dateStart');
          this.log(`fetched result`);
        }),
        catchError(this.handleError('doSearch', []))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a TchekOldService message with the MessageService */
  private log(message: string) { }

  // PARSE
  public getFolder(tchekId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Folder = parse.Object.extend('Folder');
      const query = new parse.Query(Folder);
      const eventPointer = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      };
      query.equalTo('tchekPtr', eventPointer);
      query.include('tchekPtr');
      query.include('tchekPtr.vehiclePtr');
      query.include('tchekPtr.devicePtr');
      query.include('tchekPtr.devicePtr.companyPtr');
      query.ascending('name');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getSingleFolder(tchekId: string, folderName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Folder = parse.Object.extend('Folder');
      const query = new parse.Query(Folder);
      const tchekPointer = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      };
      query.equalTo('tchekPtr', tchekPointer);
      query.equalTo('name', folderName);
      query.include('tchekPtr');
      query.include('tchekPtr.vehiclePtr');
      query.include('tchekPtr.devicePtr');
      query.include('tchekPtr.devicePtr.companyPtr');
      query.ascending('name');
      query.first().then(
        folder => {
          resolve(folder);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  public getCamera(): Promise<any> {
    return new Promise((resolve, reject) => {
      const Cam = parse.Object.extend('Camera');
      const query = new parse.Query(Cam);
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!parse.User.current().get('devicePtr')) return;
      const device = parse.Object.extend('Device');
      const query = new parse.Query(device);

      // TODO soit faire une requete pour recuperer l'id de l'user soit voir pourquoi ça marche pas le parse user current
      query.equalTo('objectId', parse.User.current().get('devicePtr').id);
      query.find().then(
        user => {
          resolve(user);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public setStatus(status: boolean, theDevice: Device): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!parse.User.current().get('devicePtr') && !theDevice) return;
      const device = parse.Object.extend('Device');
      const query = new parse.Query(device);
      query.equalTo('objectId', theDevice ? theDevice.id : parse.User.current().get('devicePtr').id);
      query.first({
        success: function (object) {
          object.set('status', status);
          object.save(null, {
            success: function (dev) {
              resolve(dev);
            },
            error: function (dev, error) {
              alert('Error save: ' + error.code + ' ' + error.message);
              reject(error);
            }
          });
          resolve(object);
        },
        error: function (error) {
          alert('Error find: ' + error.code + ' ' + error.message);
          reject(error);
        }
      });
    });
  }

  public deleteTchek(tcheks: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(tchek);
      query.containedIn('objectId', tcheks);
      query.find().then(
        object => {
          for (let i = 0; i < object.length; i++) {
            object[i].set('isDeleted', true);
            object[i].set('toSync', true);
          }
          parse.Object.saveAll(object).then(
            (obj) => {
              resolve(obj);
            },
            (err) => {
              reject(err);
            }
          );
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public addEventDeviceUpdate(devId): void {
    if (!parse.User.current()) return;
    if (!parse.User.current().get('devicePtr') && !devId) return;
    const query = new parse.Query('Device');
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = query.subscribe();

    query.equalTo(
      'objectId',
      devId ? devId : parse.User.current().get('devicePtr').id
    );

    this.subscription.on('update', object => {
      this.changeStatus(object.get('status'));
    });
  }

  // public addEventDeviceUpdate(): void {
  //   let query = new parse.Query("Tchek");
  //
  //   this.subscription = query.subscribe();
  //
  //   query.equalTo("objectId",devId ? devId : parse.User.current().get("devicePtr").id);
  //
  //   this.subscription.on("update", object => {
  //   });
  // }

  public setDistant(distant: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      const device = parse.Object.extend('Device');
      const query = new parse.Query(device);
      let devId;
      // var dev = parse.Object.extend("Device");

      //  console.log("before = ", parse.User.current());
      //
      // parse.User.current().get("devicePtr").set("fromDistant", distant);
      // parse.User.current().save();
      // console.log("after = ", parse.User.current());

      query.equalTo('objectId', parse.User.current().get('devicePtr').id);
      query.first({
        success: function (object) {
          object.set('fromDistant', distant);
          object.save(null, {
            success: function (dev) {
              resolve(dev);
            },
            error: function (dev, error) {
              alert('Error save: ' + error.code + ' ' + error.message);
              reject(error);
            }
          });
          resolve(object);
        },
        error: function (error) {
          alert('Error find: ' + error.code + ' ' + error.message);
          reject(error);
        }
      });
    });
  }

  public fetchUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = parse.Object.extend('User');
      const query = new parse.Query(user);
      query.include('settingsPtr')
      query.include('companyPtr');
      query.include('companyPtr.iamPtr');
      query.include('companyPtr.settingsPtr');
      query.include('companyPtr.settingsPtr.APITokenPtr');
      query.include('devicePtr');
      query.include('permissionPtr');
      query.equalTo('objectId', parse.User.current().id);
      query.first().then(
        user => {
          resolve(user);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  public getUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = parse.Object.extend('User');
      const query = new parse.Query(user);

      query.equalTo('objectId', parse.User.current().id);
      query.find().then(
        user => {
          resolve(user);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getRois(tchekId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const Roi = parse.Object.extend('Roi');
      const query = new parse.Query(Roi);
      const eventPointer = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      };
      query.limit(10000);
      query.equalTo('tchekPtr', eventPointer);
      query.equalTo('isAuto', true);
      query.include('tchekPtr');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getDevices(companyPtr: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const companyPointer = {
        __type: 'Pointer',
        className: 'Company',
        objectId: companyPtr
      };

      const device = parse.Object.extend('Device');
      const query = new parse.Query(device);

      // query.equalTo("companyPtr", companyPointer);
      query.find().then(
        device => {
          resolve(device);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  //
  // public getUserDevice(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     var device = parse.Object.extend("Device");
  //     var query = new parse.Query(device);
  //
  //     query.equalTo("objectId", parse.User.current().get("devicePtr").id);
  //     query.first().then(
  //       res => {
  //         if (res && res.get("spaceAlert"))
  //           resolve("L'espace de votre disque dur en local est presque pleine !");
  //         resolve(null);
  //       },
  //       error => {
  //         reject(error);
  //       });
  //   });
  // }

  public setUserDevice(deviceId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = parse.Object.extend('User');
      const query = new parse.Query(user);
      const devicePtr = {
        __type: 'Pointer',
        className: 'Device',
        objectId: deviceId
      };

      parse.User.current().set('devicePtr', devicePtr);
      parse.User.current().save();
      resolve(parse.User.current());
      // query.equalTo("objectId", parse.User.current().id);
      // query.first({
      //   success: function(object) {
      //     object.set("devicePtr", devicePtr);
      //     object.save(null, {
      //       success: function(dev) {
      //         console.log("set device successful");
      //         resolve(dev);
      //       },
      //       error: function(dev, error) {
      //         alert("Error save: " + error.code + " " + error.message);
      //         reject(error);
      //       }
      //     });
      //     resolve(object);
      //   },
      //   error: function(error) {
      //     alert("Error find: " + error.code + " " + error.message);
      //     reject(error);
      //   }
      // });
    });
  }

  public getDetails(tchekId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Details = parse.Object.extend('Picture');
      const query = new parse.Query(Details);
      const tchekPointer = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      };
      query.equalTo('tchekPtr', tchekPointer);
      query.equalTo('isSelected', true);
      query.include('tchek');
      query.include('tchekPtr');
      query.include('comparePtr');
      query.include('tchekPtr.vehicle');
      query.descending('createdAt');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public deletePicture(pictureId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const picture = parse.Object.extend('Picture');
      const query = new parse.Query(picture);
      query.equalTo('objectId', pictureId);
      query.first({
        success: function (object) {
          object.set('isSelected', false);
          object.set('toSync', true);
          object.save(null, {
            success: function (pic) {
              resolve(pic);
            },
            error: function (pic, error) {
              alert('Error delete: ' + error.code + ' ' + error.message);
              reject(error);
            }
          });
          resolve(object);
        },
        error: function (error) {
          alert('Error find: ' + error.code + ' ' + error.message);
          reject(error);
        }
      });
    });
  }


  public getTchek(tchekID: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      query.equalTo('objectId', tchekID);
      //query.notEqualTo('isDeleted', true);
      query.include('vehiclePtr');
      query.include('companyPtr');
      query.include('devicePtr');
      query.include('devicePtr.companyPtr');
      query.first().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }


  public getTcheks(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this._globals.role === '') {
        this.parseSvc.getRoles(this._globals);
      }

      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      // let subscription = query.subscribe();
      // console.log("before subscribe ", subscription);
      // subscription.on('update', (object) => {
      //   console.log('object updated');
      // });
      query.notEqualTo('isDeleted', true);
      query.include('vehiclePtr');
      query.include('devicePtr');
      query.include('vehicle');
      query.descending('tchekCreatedAt');
      // query.include('event');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getTcheksByVehicleId(vehicleID): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this._globals.role == "") {
      //   this.parseSvc.getRoles(this._globals);
      // }
      const vehiclePtr = {
        __type: 'Pointer',
        className: 'Vehicle',
        objectId: vehicleID
      };
      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      query.notEqualTo('isDeleted', true);
      query.equalTo('vehiclePtr', vehiclePtr);
      query.include('vehiclePtr');
      query.include('devicePtr');
      query.descending('tchekCreatedAt');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public doSearchOld(
    search: string,
    dateStart: string,
    dateEnd: string,
    intervalTime: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const Vehicle = parse.Object.extend('Vehicle');
      const queryVehicle = new parse.Query(Vehicle);
      if (typeof search !== 'undefined') queryVehicle.contains('immat', search);

      // queryVehicle.contains(search);
      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      // query.equalTo("user", parse.User.current());
      query.include('vehiclePtr');
      query.include('devicePtr');
      query.descending('tchekCreatedAt');

      // if (typeof dateStart != "undefined")
      //   query.contains("createdAt", "2018-04-25");

      query.matchesQuery('vehicle', queryVehicle);

      // query.include('event');
      query.find().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public favPicture(
    number: number,
    cameraId: string,
    tchekdId: string,
    isSelected: boolean,
    notif: any,
    filters?: FavoritePictureFilters
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('selectPicture', {
        pictureNumber: number,
        cameraName: cameraId,
        tchekId: tchekdId,
        isSelected: isSelected,
        filters: filters
      }).then(
        function (result) {
          // make sure the set the email sent flag on the object
          if (isSelected) {
            notif.success(
              'Succès',
              'Cette photographie a été sauvegardée dans vos favoris. Pour la désélectionner, veuillez cliquer à nouveau sur l’étoile.',
              {
                timeOut: 4500,
                showProgressBar: false,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
            );
          } else {
            notif.success(
              'Succès',
              'Cette photographie a été retirée de vos favoris. Pour la rajouter, veuillez cliquer à nouveau sur l’étoile.',
              {
                timeOut: 4500,
                showProgressBar: false,
                pauseOnHover: false,
                clickToClose: true,
                maxLength: 50
              }
            );
          }
          resolve(result);
        },
        function (error) {
          notif.success(
            'Erreur',
            'L\'opération sur les favoris a échoué.',
            {
              timeOut: 4500,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            });
          console.error('parse.Cloud function selectPicture() failed : ', error);
          reject(error);
        }
      );
    });

  }

  public favPicturesInComparison(picturesToFav: ComparisonPicturesFav, notif: NotificationsService
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('selectTwoPictures', {
        picture1: picturesToFav.picture1,
        picture2: picturesToFav.picture2
      }).then(function (result) {
        // make sure the set the email sent flag on the object
        if (result.picture1.get('isSelected')) {
          notif.success(
            'Succès',
            'Ces photographies ont été sauvegardées dans vos favoris. Pour les désélectionner, veuillez cliquer à nouveau sur l’étoile.',
            {
              timeOut: 4500,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
          );
        } else {
          notif.success(
            'Succès',
            'Ces photographies ont été retirées de vos favoris. Pour les rajouter, veuillez cliquer à nouveau sur l’étoile.',
            {
              timeOut: 4500,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
          );
        }
        resolve(result);
      },
        function (error) {
          notif.success(
            'Erreur',
            'L\'opération sur les favoris a échoué.',
            {
              timeOut: 4500,
              showProgressBar: false,
              pauseOnHover: false,
              clickToClose: true,
              maxLength: 50
            }
          );
          console.error('parse.Cloud function selectPicture() failed : ', error);
          reject(error);
        }
      );
    });

  }

  public getAllFavPictures(tchekId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('Picture'));
      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      });
      query.equalTo('isSelected', true);
      query.find().then((retrievedPictures) => {
        const favMatrix = [];
        for (let i = 0; i < retrievedPictures.length; i++) {
          favMatrix.push({
            folder: retrievedPictures[i].get('cameraName'),
            picture: retrievedPictures[i].get('pictureNumber')
          });
        }
        resolve(favMatrix);
      }, (error) => {
        console.error('Could not retrieve favorite pictures for Tchek ', tchekId, ' : ', error.code, error.message);
        reject(error);
      });
    });
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    const file = new File([blob], 'sig.png', {
      type: contentType,
      lastModified: Date.now()
    });
    return file;
  }

  splitSig(sig) {
    const block = sig.split(';');
    // Get the content type of the image
    const contentType = block[0].split(':')[1]; // In this case "image/gif"
    // get the real base64 content of the file
    const realData = block[1].split(',')[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."

    // Convert it to a blob to upload
    const blob = this.b64toBlob(realData, contentType, 512);

    const parseFile = new parse.File('sig.png', blob);
    return parseFile;
  }

  public sign(kmDepart, kmRetour, reservoir, numeroContrat, customer, tchekId): Promise<any> {
    return new Promise((resolve, reject) => {
      const contrat = parse.Object.extend('Contract');
      const query = new parse.Query(contrat);
      query.equalTo('numeroContrat', numeroContrat);
      query.first().then(contr => {
        // console.log('updating contract', contr);
        contr.set('kmDepart', parseInt(kmDepart));
        contr.set('kmRetour', parseInt(kmRetour));
        contr.set('niveauCarbRetour', parseInt(reservoir));
        contr.save().then(contr2 => {
          // console.log('done updating contract', contr2);
          const tchek = parse.Object.extend('Tchek');
          const query = new parse.Query(tchek);
          query.equalTo('objectId', tchekId);
          query.first().then(
            res => {
              // console.log('updating tchek', res);
              /* res.set('isSigned', true);
              res.set('customerSignature', this.splitSig(customer));
              res.set('dateSignature', new Date()); */
              res.set('contractPtr', contr2);
              res.save().then(
                obj => {
                  // console.log('done updating tchek', res);
                  resolve(obj);
                },
                error => {
                  console.error('Error save: ' + error.code + ' ' + error.message);
                  reject(error);
                }
              );
            },
            error => {
              reject(error);
            }
          );
        }, error => {
          console.error('Error save: ' + error.code + ' ' + error.message);
          reject(error);
        });
      });

    });
  }

  public getAllTchek(): Promise<any> {
    return new Promise((resolve, reject) => {
      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      query.count({
        success: function (count) {
          resolve(count);
        },
        error: function (error) {
          reject(error);
        }
      });
    });
  }

  public getAllVehicle(): Promise<any> {
    return new Promise((resolve, reject) => {
      const Vehicle = parse.Object.extend('Vehicle');
      const query = new parse.Query(Vehicle);
      query.count({
        success: function (count) {
          resolve(count);
        },
        error: function (error) {
          reject(error);
        }
      });
    });
  }

  public addClient(
    firstname,
    lastname,
    email,
    room,
    tchekId,
    type,
    vehicleId
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
      acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), false);

      const Client = parse.Object.extend('Client');
      const client = new Client();

      const tchekPtr = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      };

      const vehiclePtr = {
        __type: 'Pointer',
        className: 'Vehicle',
        objectId: vehicleId
      };

      client.set('firstname', firstname);
      client.set('lastname', lastname);
      client.set('email', email);
      client.set('room', room);
      client.set('tchekPtr', tchekPtr);
      client.set('vehiclePtr', vehiclePtr);
      client.setACL(acl);

      client.save(null, {
        success: function (client) {
          const clientPtr = {
            __type: 'Pointer',
            className: 'Client',
            objectId: client.id
          };

          const userPtr = {
            __type: 'Pointer',
            className: '_User',
            objectId: parse.User.current().id
          };

          const Activity = parse.Object.extend('Activity');
          const activity = new Activity();
          activity.set('type', type);
          activity.set('clientPtr', clientPtr);
          activity.set('tchekPtr', tchekPtr);
          activity.set('userPtr', userPtr);
          activity.set('vehiclePtr', vehiclePtr);
          activity.setACL(acl);

          activity.save(null, {
            success: function (activity) {
              resolve(activity);
            },
            error: function (activity, error) {
              reject(error);
            }
          });
        },
        error: function (client, error) {
          reject(error);
        }
      });
    });
  }

  public getClient(tchekID: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Client = parse.Object.extend('Client');
      const query = new parse.Query(Client);

      const tchekPtr = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekID
      };

      query.equalTo('tchekPtr', tchekPtr);
      query.find().then(
        client => {
          resolve(client);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getActivity(vehicleId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Activity = parse.Object.extend('Activity');
      const query = new parse.Query(Activity);

      const vehiclePtr = {
        __type: 'Pointer',
        className: 'Vehicle',
        objectId: vehicleId
      };

      query.equalTo('vehiclePtr', vehiclePtr);
      query.include('tchekPtr');
      query.include('userPtr');
      query.include('clientPtr');
      query.include('vehiclePtr');
      query.descending('createdAt');
      query.find().then(
        activity => {
          resolve(activity);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public saveVehicle(
    vehicleId: string,
    immat: string,
    brand: string,
    model: string,
    tchekId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('updateVehicle', {
        vehicleId: vehicleId,
        immat: immat,
        brand: brand,
        model: model,
        tchekId: tchekId
      }).then(
        function (result) {
          // make sure the set the email sent flag on the object
          resolve(result);
        },
        function (error) {
          // alert("Error save: " + error.code + " " + error.message);
          reject(error);
          // error
        }
      );

      /*  var Vehicle = parse.Object.extend("Vehicle");
       var query = new parse.Query(Vehicle);
       query.equalTo("objectId", vehicleId);
       query.first({
         success: function(object) {
           object.set("immat", immat);
           object.set("brand", brand);
           object.set("model", model);
           object.save(null, {
             success: function(veh) {
               resolve(veh);
             },
             error: function(veh, error) {
               alert("Error save: " + error.code + " " + error.message);
               reject(error);
             }
           });
           resolve(object);
         },
         error: function(error) {
           alert("Error save: " + error.code + " " + error.message);
           reject(error);
         }
       }); */
    });
  }

  public getNumberTchekMonth(): Promise<any> {
    return new Promise((resolve, reject) => {
      /*       var company = parse.User.current().get("companyPtr");
 */
      const thos = this;
      const user = parse.Object.extend('_User');
      const query2 = new parse.Query(user);
      query2.include('companyPtr');
      query2.equalTo('objectId', parse.User.current().id);
      query2.first().then(
        user => {
          const company = user.get('companyPtr');
          const number_tchek = company.get('number_tchek');
          const firstDate = company.get('firstDate');

          const dates = this.giveRangeDate(firstDate);
          const Tchek = parse.Object.extend('Tchek');
          const query = new parse.Query(Tchek);
          query.greaterThan('tchekCreatedAt', dates[0]);
          query.lessThan('tchekCreatedAt', dates[1]);
          query.count({
            success: function (count) {
              const tchek_available = number_tchek - count;
              const message = thos.i18n({
                id: 'message_tchek_available',
                value: 'Il vous reste %d  Tchek, disponibles jusqu\'au',
                description: 'Il vous reste %d  Tchek, disponibles jusqu\'au',
                meaning: 'tchek.service'
              });
              const format = (...args) =>
                args
                  .shift()
                  .replace(
                    /%([jsd])/g,
                    x =>
                      x === '%j' ? JSON.stringify(args.shift()) : args.shift()
                  );

              const messages2 = format(
                message,
                tchek_available,
                thos.datePipe.transform(dates[1], 'fullDate')
              );
              resolve(messages2);
            },
            error: function (error) {
              alert('Error save: ' + error.code + ' ' + error.message);
              reject(error);
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    });
  }

  giveRangeDate(firstDate) {
    const currentTime = new Date();
    const year = currentTime.getFullYear();
    const day = firstDate.getDate();
    const month = currentTime.getMonth();
    if (firstDate.getDate() > currentTime.getDate()) {
      const date1 = new Date(year, month - 1, day);
      const date2 = new Date(year, month, day - 1);
      return [date1, date2];
    } else {
      const date1 = new Date(year, month, day);
      const date2 = new Date(year, month + 1, day - 1);
      return [date1, date2];
    }
  }

  public syncHitech(notif: any): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('syncHitech', {}).then(
        function (result) {
          console.log('Sync result', result);
          notif.success('Succès', 'Synchronisation terminée.', {
            timeOut: 4500,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          });
          resolve(result);
        },
        function (error) {
          console.log('Sync failed', error);
          reject(error);
        }
      );
    });
  }

  public sendPdfState(notif: any, cloudArgs: PdfStateCloudArguments): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('pdfState', cloudArgs).then(
        function (result) {
          // console.log('pdfState result', result);
          notif.success('Succès', 'Le rapport a bien été envoyé par e-mail.', {
            timeOut: 4500,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          });
          resolve(result);
        },
        function (error) {
          console.log('pdfState failed', error);
          reject(error);
        }
      );
    });
  }

  public setUploadHd(tchekId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const _Tchek = parse.Object.extend("Tchek");
      const query = new parse.Query(_Tchek);
      query.get(tchekId).then(tchek => {
        tchek.set({ toDownload: 1, toSync: true, uploadHDPictures: false, videoConverter: 0 });
        tchek.save().then(savedTchek => {
          console.log('tchek set to upload HD', savedTchek);
          resolve(savedTchek);
        }, error => {
          console.error('Cannot set tchek to upload HD', tchekId, error);
          reject(error);
        });
      }, error => {
        console.error('Cannot find tchek to edit', tchekId, error);
        reject(error);
      });
    });
  }

  public setExtractVideo(tchekId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const _Tchek = parse.Object.extend("Tchek");
      const query = new parse.Query(_Tchek);
      query.get(tchekId).then(tchek => {
        tchek.set({ toSync: true, uploadHDPictures: false, videoConverter: 1 });
        tchek.save().then(savedTchek => {
          console.log('tchek set to extract video', savedTchek);
          resolve(savedTchek);
        }, error => {
          console.error('Cannot set tchek to extract video', tchekId, error);
          reject(error);
        });
      }, error => {
        console.error('Cannot find tchek to edit', tchekId, error);
        reject(error);
      });
    });
  }

  public updateContract(payload: ContractUpdate): Promise<any> {
    return new Promise((resolve, reject) => {
      parse.Cloud.run('updateHitechContract', { payload }).then(
        result => {
          this.notif.success('Succès', 'La contrat a bien été mis à jour.', {
            timeOut: 4500,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          });
          resolve(result);
        },
        error => {
          console.log('Sync failed', error);
          reject(error);
        }
      );
    });
  }
}

export interface ComparisonPicturesFav {
  picture1: PictureFav;
  picture2: PictureFav;
}

export interface PictureFav {
  pictureNumber: number;
  cameraName: string;
  tchekId: string;
  isSelected: boolean;
  filters?: FavoritePictureFilters;
}

export class PdfStateCloudArguments {
  private tchekId: string;
  private contractUpdate: ContractUpdate;

  constructor(tchekId: string, contractUpdate: ContractUpdate) {
    this.tchekId = tchekId;
    this.contractUpdate = contractUpdate;
  }
}


// WEBPACK FOOTER //
// ./src/app/service/tchek-old.service.ts